import React, { useContext } from 'react'

// Node Modules
import Nav from 'react-bootstrap/Nav'

// Styles
import styles from './CASLanguage.module.scss'

// Context
import { CasLanguageState, CasLanguageDispatch } from 'context/cas-format-context'

const languages = [
  "SAS",
  "Lua",
  "Python",
  "R"
]

const CASLanguage = () => {
  const state = useContext(CasLanguageState)
  const dispatch = useContext(CasLanguageDispatch)

  function label(language: string) {
    return language === "SAS" ? "CASL" : language
  }

  return (
    <div className={styles.casLanguage}>
      <Nav variant="pills" activeKey={state}>
        {
          languages.map(l => (
            <Nav.Item key={l}>
              <Nav.Link eventKey={l} onSelect={() => dispatch(l)} role="button">{ label(l) }</Nav.Link>
            </Nav.Item>
          ))
        }
      </Nav>
    </div>
  )
}

export default CASLanguage